export default "__VITE_ASSET__DatYcBcj__"